import "../node_modules/swing-ui/dist/css/swing.min.css";
import wvusFlexCheckout from "./wvusFlexCheckout";

// See wvusFlexCheckout
globalThis.wvusFlexCheckout = wvusFlexCheckout;
